"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isLocal = exports.isQa = exports.isProd = exports.getShort = exports.deployed = exports.debug = exports.ENV_NAME = void 0;

var _enviro = _interopRequireDefault(require("enviro"));

var ENV_NAME = 'MarketplaceUI';
exports.ENV_NAME = ENV_NAME;

var debug = function debug() {
  var envName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ENV_NAME;
  return _enviro.default.debug(envName);
};

exports.debug = debug;

var deployed = function deployed() {
  return _enviro.default.deployed(ENV_NAME);
};

exports.deployed = deployed;

var getShort = function getShort() {
  return _enviro.default.getShort(ENV_NAME);
};

exports.getShort = getShort;

var isProd = function isProd() {
  return _enviro.default.isProd(ENV_NAME);
};

exports.isProd = isProd;

var isQa = function isQa() {
  return _enviro.default.isQa(ENV_NAME);
};

exports.isQa = isQa;

var isLocal = function isLocal() {
  return _enviro.default.getShort(ENV_NAME) === 'local';
};

exports.isLocal = isLocal;